import { render } from "./ImportItem.vue?vue&type=template&id=66809928&scoped=true"
import script from "./ImportItem.vue?vue&type=script&lang=js"
export * from "./ImportItem.vue?vue&type=script&lang=js"

import "./ImportItem.vue?vue&type=style&index=0&id=66809928&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66809928"]])

export default __exports__